import React from 'react';

import RecentlyPlayedMenu from '../../../left-bar/RecentlyPlayedMenu';
import HomeMenu from '../../../left-bar/HomeMenu';
import GenresMenu from '../../../left-bar/GenresMenu';
import CollectionMenu from '../../../left-bar/CollectionMenu';
import MyBeatportMenu from '../mods/mybeatport/MyBeatportMenu';
import NewPlaylistMenu from '../../../left-bar/NewPlaylistMenu';
import CartMenu from '../../../cart/CartMenu';

function LeftMenuSection({ onSelectGenres }) {
  return (
    <div className={`flexColumn`} style={{margin: 8}}>
      <HomeMenu />
      <GenresMenu onClick={onSelectGenres} />
      <MyBeatportMenu />
      <CollectionMenu />
      <CartMenu />
      <RecentlyPlayedMenu />
      <NewPlaylistMenu />
    </div>
  )
}

export default LeftMenuSection;
